import React from "react";
import Reveal from "../common/Reveal";
import stack from "../data/stack";

export default function Stack() {
  return (
    <section className="section">
      <div className="section-inner">
        <Reveal className="section-label-row">
          <span className="section-label mono">02 / STACK</span>
          <span className="section-line" />
        </Reveal>

        <div className="stack-grid stagger">
          {stack.map((col) => (
            <Reveal as="div" className="stack-col" key={col.label}>
              <div className="stack-col-label mono">{col.label}</div>
              <div className="stack-col-list">
                {col.items.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
